import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getExtraQuizThunk = createAsyncThunk(
  "extra/get",
  async (params) => {
    const { usertype, topicId } = params;
    console.log(topicId,usertype,"usertype action");
    let response = await api.get(
      "getTchExtraModulesContentsQuiz/" +
      usertype +
        "/" +
        topicId
         );
    return response.data;
  }
);

export const getExtraTopicThunk = createAsyncThunk(
  "extra/getAllTchExtraModulesTopics",
  async (usertype) => {
    let response = await api.get("getAllTchExtraModulesTopics/" + usertype + "/" + "od");
    return response.data;
  }
);

export const createExtraQuizThunk = createAsyncThunk(
  "extra/create",
  async (body) => {
    let response = await api.put("updateTchExtraModulesContentAssignmentData", body);
    return response.data;
  }
);

export const updateExtraQuizThunk = createAsyncThunk(
  "extra/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body
    let response = await api.put("updateTchExtraModulesContentAssignmentData" + id, body);
    return response.data;
  }
);

export const deleteExtraQuizThunk = async(data) =>
await api.put(`updateTchExtraModulesContentAssignmentData`,data);